var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-DataTools"},[_c('ado-left',{attrs:{"id":_vm.id,"sliders":_vm.sliders,"portname":_vm.portname,"token":_vm.token},on:{"changeid":_vm.changeidHandler}}),(_vm.showRight)?_c('ado-right',{attrs:{"id":_vm.id,"portname":_vm.portname,"token":_vm.token,"type":_vm.type}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }